/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RegisteredCompanyInput} from "./registeredCompanyInput.zod";
import {SupplierRole} from "./supplierRole.zod";
import {SupplierStandardization} from "./supplierStandardization.zod";
import {SupplierStatus} from "./supplierStatus.zod";

export const updateSupplierRequestDeliveryTimeDaysMin = 0;

export const updateSupplierRequestPaymentTimeDaysMin = 0;

export const UpdateSupplierRequest = zod.object({
  company: RegisteredCompanyInput,
  logoUrl: zod.string().optional(),
  status: SupplierStatus,
  roles: zod.array(SupplierRole).min(1),
  standardization: SupplierStandardization,
  deliveryTimeDays: zod.int().min(updateSupplierRequestDeliveryTimeDaysMin),
  paymentTimeDays: zod.int().min(updateSupplierRequestPaymentTimeDaysMin),
});

export type UpdateSupplierRequest = zod.input<typeof UpdateSupplierRequest>;
export type UpdateSupplierRequestOutput = zod.output<typeof UpdateSupplierRequest>;
